import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import BrandLogo from '../../Elements/BrandLogo/BrandLogo'
import DownChevron from '../../../../Assets/icons/DownChevron.svg'
import Image from '../../Elements/Image/Image'
import { logout, reset } from '../../../../Redux/Features/Auth/authSlice'

import './Navbar.css'

function Navbar() {

   const { consumer } = useSelector(state => state.auth)
   const [isShow, setIsShow] = useState("false");

   const dispatch = useDispatch()

   const handleToggle = () => {
      setIsShow(!isShow);
   }
   // const hideDropdown = () => {
   //    setIsShow(!isShow);
   // }

   function handleLogout() {
      dispatch(logout());
      dispatch(reset());
      handleToggle();
   }

   return (
      <>
         <div className="Navbar_section">
            <nav className='Navbar'>
               <div className="row">
                  <div className="nav_logo">
                     <BrandLogo />
                  </div>

                  <div className={`login_info_wrap`}>
                     {consumer &&
                        <>
                           <button type='button' onClick={handleToggle} className='consumerInfo'>
                              <Image imgSrc={consumer.image} imgAlt={consumer.name} />
                              <span>{consumer.name}</span>
                              <img src={DownChevron} alt="angle-down" className='down_chevron' />
                           </button>
                           <div className={`user_login_dropdown ${isShow ? 'hide' : ''}`}>
                              {
                                 consumer
                                    ?
                                    consumer.language === 'english'
                                       ?
                                       <>
                                          <Link to='/profile/my-profile' onClick={handleToggle}>My Profile</Link>
                                          <Link to='/login' onClick={handleLogout}>Logout</Link>
                                       </>
                                       :
                                       <>
                                          <Link to='/profile/my-profile' onClick={handleToggle}>আমার প্রোফাইল</Link>
                                          <Link to='/login' onClick={handleLogout}>সাইন আউট</Link>
                                       </>
                                    :
                                    <>
                                       <Link to='/profile/my-profile' onClick={handleToggle}>আমার প্রোফাইল</Link>
                                       <Link to='/login' onClick={handleLogout}>সাইন আউট</Link>
                                    </>
                              }

                           </div>
                        </>
                     }
                     {!consumer &&
                        <div className="nav_btn">
                           <Link to='/login' className='login_btn'>লগ ইন</Link>
                        </div>
                     }
                  </div>
               </div>
            </nav>
         </div>
      </>
   )
}

export default Navbar